export const IQ_HUB_API_URL = process.env.REACT_APP_IQ_HUB_API_URL;
export const IQ_HUB_TOKEN_NAME = process.env.REACT_APP_IQ_HUB_TOKEN_NAME;
export const IQ_HUB_GOOGLE_CLIENT_ID =
  process.env.REACT_APP_IQ_HUB_GOOGLE_CLIENT_ID;
export const IQ_HUB_ASSETS_CDN_BASE_URL =
  process.env.REACT_APP_IQ_HUB_ASSETS_CDN_BASE_URL;

export const APP_ROUTE_LOGIN = "/login";
export const APP_ROUTE_SIGNUP = "/signup";
export const APP_ROUTE_FORGOT_PASSWORD = "/forgotpassword";
export const APP_ROUTE_DASHBOARD = "/dashboard";
export const APP_ROUTE_REPORT = "/report";
export const APP_ROUTE_IQTECHMAX = "/iqtechmax";
export const APP_ROUTE_SUPER_ADMIN = "/super-admin-org";
export const APP_ROUTE_BLOG = "/blog";
export const APP_ROUTE_BANNER = "/banner";
export const APP_ROUTE_TESTIMONIAL = "/testimonial";
export const APP_ROUTE_CASE_STUDIES = "/case-studies";
export const APP_ROUTE_IMAGE_GALLERY = "/image-gallery";
export const APP_ROUTE_APP_SETTINGS = "/appsettings";
export const APP_ROUTE_MANAGE_ORGANIZATION = "/manageorganization";

export const APP_PATH_LOGIN = "login";
export const APP_PATH_SIGNUP = "signup";
export const APP_PATH_FORGOT_PASSWORD = "forgotpassword";
export const APP_PATH_DASHBOARD = "dashboard";
export const APP_PATH_REPORT = "report";
export const APP_PATH_IQTECHMAX = "iqtechmax";
export const APP_PATH_SUPER_ADMIN = "super-admin-org";
export const APP_PATH_BLOG = "blog";
export const APP_PATH_BANNER = "banner";
export const APP_PATH_TESTIMONIAL = "testimonial";
export const APP_PATH_CASE_STUDIES = "case-studies";
export const APP_PATH_IMAGE_GALLERY = "image-gallery";
export const APP_PATH_APP_SETTINGS = "appsettings";
export const APP_PATH_MANAGE_ORGANIZATION = "manageorganization";

export const APP_CONSTANT_INVALID_PASSWORD = "INVALID_PASSWORD";
export const APP_CONSTANT_INVALID_EMAIL = "INVALID_EMAIL";
export const APP_CONSTANT_INVALID_NAME = "INVALID_NAME";
export const APP_CONSTANT_PASSWORD_NOT_MATCH = "PASSWORD_NOT_MATCH";
export const APP_CONSTANT_INVALID_CREDENTIALS = "INVALID_CREDENTIALS";

export const APP_ROUTE_IQAGENT = "https://iq-agent.in";
export const APP_ROUTE_IQLENS = "https://iqtechmax.com/iqlens";
export const APP_ROUTE_IQVERSE = "https://iqtechmax.com/IQ-Verse";

export const productCardDetails = [
  {
    title: "IQ Agent",
    icon: `${IQ_HUB_ASSETS_CDN_BASE_URL}/assets/images/Iq-agent_logo.svg`,
    description: "Leverage AI assistants to streamline operations.",
    link: APP_ROUTE_IQAGENT,
  },
  {
    title: "IQ Lens",
    icon: `${IQ_HUB_ASSETS_CDN_BASE_URL}/assets/images/iq_lens_logo.svg`,
    description:
      "At IQTechMax, we built IQ Lens as an AI-powered AR/VR solution that transforms how people interact with information. IQ Lens brings real-time visual insights, immersive training, and smart assistance to industries, helping teams work faster, safer, and with greater accuracy. It’s our way of blending intelligence with experience to make technology more human-centric. ",
    link: APP_ROUTE_IQLENS,
  },
  {
    title: "IQ Verse",
    icon: `${IQ_HUB_ASSETS_CDN_BASE_URL}/assets/images/iq_verse_logo.svg`,
    description: "Explore immersive, interactive environments.",
    link: APP_ROUTE_IQVERSE,
  },
];
export const sideBarNavLinks = [
  { path: APP_ROUTE_DASHBOARD, name: "Dashboard" },
  {
    path: APP_ROUTE_REPORT,
    name: "Report",
    // Wrapper: IsComponentAllowed,
    // wrapperProps: { accessName: "report_access" },
  },
  {
    path: APP_ROUTE_SUPER_ADMIN,
    name: "Super Admin Panel",
    // Wrapper: IsSuperAdmin,
    child: [
      { path: APP_ROUTE_APP_SETTINGS, name: "App Settings", child: [] },
      {
        path: APP_PATH_MANAGE_ORGANIZATION,
        name: "Manage Organization",
        child: [],
      },
      {
        path: APP_ROUTE_IQTECHMAX,
        name: "IQ TechMax",
        child: [
          {
            path: `${APP_ROUTE_SUPER_ADMIN}${APP_ROUTE_DASHBOARD}`,
            name: "Dashboard",
          },
          {
            path: `${APP_ROUTE_SUPER_ADMIN}${APP_ROUTE_BLOG}`,
            name: "Blog",
          },
          {
            path: `${APP_ROUTE_SUPER_ADMIN}${APP_ROUTE_BANNER}`,
            name: "Banner",
          },
          {
            path: `${APP_ROUTE_SUPER_ADMIN}${APP_ROUTE_TESTIMONIAL}`,
            name: "Testimonial",
          },
          {
            path: `${APP_ROUTE_SUPER_ADMIN}${APP_ROUTE_CASE_STUDIES}`,
            name: "Case Studies",
          },
          {
            path: `${APP_ROUTE_SUPER_ADMIN}${APP_ROUTE_IMAGE_GALLERY}`,
            name: "Image Gallery",
          },
        ],
      },
    ],
  },
];
